module.exports = __webpack_public_path__ + "static/AAA-logo-9f1922bf67bb591f45a13ff2fc91cc9a.jpg";